<template lang="pug">
    el-dialog(:title="title", width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="比赛ID" prop="matchId")
                    div.width_label {{ruleForm.matchId}}
                el-form-item(label="比赛名称" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="比赛类别")
                    div.width_label 分级公开赛
                el-form-item(label="主办单位" prop="orgName")
                    div.width_label {{ruleForm.orgName}}
                el-form-item(label="比赛场地")
                    div.width_label {{ruleForm.placeName}}
                br
                el-form-item(label="赛事类型" prop="ctType")
                        div.width_label(v-if="ruleForm.ctType === 1") 常规赛
                        div.width_label(v-if="ruleForm.ctType === 2") 月度赛
                        div.width_label(v-if="ruleForm.ctType === 3") 季度赛
                        div.width_label(v-if="ruleForm.ctType === 4") 年度总决赛
                el-form-item(label="比赛项目" prop="projectType")
                        div.width_label(v-if="ruleForm.projectType === 1") 单打
                        div.width_label(v-if="ruleForm.projectType === 2") 双打
                el-form-item(label="级别" prop="level")
                        div.width_label {{ruleForm.level}}
                el-form-item(label="签位" prop="applySize")
                        div.width_label {{ruleForm.joinCount}}/{{ruleForm.applySize}} 签
                br
                el-form-item(label="比赛时间")
                        div.width_label {{ruleForm.matchStartTime}}
                el-form-item(label="状态")
                    div.width_label(v-if="ruleForm.matchStatus == 2") {{ruleForm.statusName}}
                    div.width_label(v-if="ruleForm.matchStatus == 3") 已取消
                    div.width_label(v-if="ruleForm.matchStatus == 4") 已结束
                //- el-form-item(v-if="ruleForm.projectType === 2" label="排序")
                //-     el-select(v-model="ruleForm.orderForm" @change="orderChange")
                //-         el-option(label="按级别和-积分和" :value=1 )
                //-         el-option(label="按级别差-积分和" :value=2 )
            el-row(style="padding-top:30px")
                el-col(:span="24")
                    el-button(type="primary" @click="addEnrollView" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 添加人员
                    el-button(type="danger" @click="delEnroll" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除人员
                    el-button(type="primary" @click="clickRefund" :disabled="ruleForm.matchStatus==4") 退 款
                    el-button(type="primary" @click="exportExcel") 名单导出
                    el-button(type="primary" @click="addEnrollView('wildCard')" :disabled="ruleForm.enrollDisabled || ruleForm.matchStatus == 4 || ruleForm.joinCount >= ruleForm.applySize") 发放外卡
            el-row(style="padding-top:10px")
                el-col(:span="24")
                   el-card(shadow="never")
                      div(slot="header" class="headTitle")
                        div
                            font.font_label 参赛人员
                        div
                            //- el-button(type="primary" @click='openSortFormatr') 调整赛制
                            //- el-button(type="primary" @click='openSortNumber') 调整排序号
                      div
                        el-table(:data="enrollDataOne" border @selection-change="enrollOneChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column( prop="wildCard" label="报名方式" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.wildCard ? '外卡报名' : '正常报名' }}
                                el-table-column( prop="gameNum" label="参赛次数" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.gameNum || 0 }}
                                el-table-column(prop="mobile" label="会员账号" align='center' width="130")
                                el-table-column(prop="accountType" label="账户属性" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.accountType == 0") 一般账户
                                        font(v-if="scope.row.accountType == 1") 青少年账户 
                                el-table-column(prop="gender" label="性别" align='center' width="60")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width="60")
                                el-table-column(prop="level" label="级别" align='center' width="60")
                                el-table-column(prop="yearScore" label="积分" align='center' width="60")
                                    //- template(slot-scope="scope")
                                    //-   div(v-if='scope.row.ctType == 1')
                                    //-     font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                    //-     font(v-if="!scope.row.yearScore") 0
                                    //-   div(v-if='scope.row.ctType == 2')
                                    //-     font(v-if="scope.row.monthScore") {{scope.row.monthScore}}
                                    //-     font(v-if="!scope.row.monthScore ") 0
                                    //-   div(v-if='scope.row.ctType == 3')
                                    //-     font(v-if="scope.row.quarterScore") {{scope.row.quarterScore}}
                                    //-     font(v-if="!scope.row.quarterScore") 0
                                    //-   div(v-if='scope.row.ctType == 4')
                                    //-     font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                    //-     font(v-if="!scope.row.yearScore") 0
                                el-table-column(prop="enrollClubCount" label="俱乐部赛参赛次数" align='center' width="150")
                                el-table-column(prop="memberType" label="会员类型" align='center' width="130")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.memberType == 1") 注册会员
                                        font(v-if="scope.row.memberType == 2") 初始会员
                                        font(v-if="scope.row.memberType == 3") 荣誉会员
                                el-table-column(prop="payStatus" label="状态" align='center' width="80")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus == 0") 未缴费
                                        font(v-if="scope.row.payStatus == 1") 支付中
                                        font(v-if="scope.row.payStatus == 2") 已缴费
                                        font(v-if="scope.row.payStatus == 3") 支付失败
                                        font(v-if="scope.row.payStatus == 4") 超时
                                        font(v-if="scope.row.payStatus == 5") 申请退款
                                        font(v-if="scope.row.payStatus == 6") 退款中
                                        font(v-if="scope.row.payStatus == 7") 退款成功
                                        font(v-if="scope.row.payStatus == 8") 退款失败
                                        font(v-if="scope.row.payStatus == 9") 支付已关闭
                                        font(v-if="scope.row.payStatus == 10") 退款已取消
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount")
                                            span() ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null && scope.row.refundScale != 'Infinity'") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null && scope.row.refundFee != ''")
                                            span() ￥{{parseFloat(scope.row.refundFee).toFixed(2)}}元
                                el-table-column(prop="refundDesc" label="退款说明" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="!!scope.row.refundDesc") {{scope.row.refundDesc}}
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="1-1" @click="updateBench(scope.row,1)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 设为替补
                                                    el-menu-item(index="1-5" @click="clickRefund(1,scope.row)" :disabled="ruleForm.matchStatus==4") 退款
                                                    el-menu-item(index="1-2" @click="delEnroll(1,scope.row)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除人员
                                                    el-menu-item(index="1-3" @click="initDiaLogArgue(scope.row,1)" :disabled="ruleForm.matchStatus==4") 记录争议
                                                    el-menu-item(index="1-6" @click="viewParent(scope.row)" :disabled="scope.row.accountType!=1") 查看家长
                                                    el-menu-item(index="1-4" v-if="scope.row.argue !== null"  @click="initDiaLogArgue(scope.row,2)") 查看争议

            el-row(style="padding-top:30px")
                el-col(:span="24")
                    el-card(shadow="never")
                        div(slot="header")
                            font.font_label 替补人员
                        div
                            el-table(:data="enrollDataTwo" border @selection-change="enrollTwoChange")
                                el-table-column(type="selection" align='center' width='40')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column( prop="gameNum" label="参赛次数" align='center')
                                    template(slot-scope="scope")
                                        font {{ scope.row.gameNum || 0 }}
                                el-table-column(prop="mobile" label="会员账号" align='center' width='130')
                                el-table-column(prop="gender" label="性别" align='center' width='60')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center' width='60')
                                el-table-column(prop="level" label="级别" align='center' width='60')
                                el-table-column(prop="yearScore" label="积分" align='center' width='60')
                                    //- template(slot-scope="scope")
                                    //-   div(v-if='scope.row.ctType == 1')
                                    //-     font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                    //-     font(v-if="!scope.row.yearScore") 0
                                    //-   div(v-if='scope.row.ctType == 2')
                                    //-     font(v-if="scope.row.monthScore") {{scope.row.monthScore}}
                                    //-     font(v-if="!scope.row.monthScore ") 0
                                    //-   div(v-if='scope.row.ctType == 3')
                                    //-     font(v-if="scope.row.quarterScore") {{scope.row.quarterScore}}
                                    //-     font(v-if="!scope.row.quarterScore") 0
                                    //-   div(v-if='scope.row.ctType == 4')
                                    //-     font(v-if="scope.row.yearScore") {{scope.row.yearScore}}
                                    //-     font(v-if="!scope.row.yearScore") 0
                                el-table-column(prop="enrollClubCount" label="俱乐部赛参赛次数" align='center' width="150")
                                el-table-column(prop="memberType" label="会员类型" align='center' width='130')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.memberType == 1") 注册会员
                                        font(v-if="scope.row.memberType == 2") 初始会员
                                        font(v-if="scope.row.memberType == 3") 荣誉会员
                                el-table-column(prop="payStatus" label="状态" align='center' width='80')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payStatus === 0 || !scope.row.payStatus") 未缴费
                                        font(v-if="scope.row.payStatus === 1") 支付中
                                        font(v-if="scope.row.payStatus === 2") 已缴费
                                        font(v-if="scope.row.payStatus === 3") 支付失败
                                        font(v-if="scope.row.payStatus === 4") 超时
                                        font(v-if="scope.row.payStatus === 5") 申请退款
                                        font(v-if="scope.row.payStatus === 6") 退款中
                                        font(v-if="scope.row.payStatus === 7") 退款成功
                                        font(v-if="scope.row.payStatus === 8") 退款失败
                                        font(v-if="scope.row.payStatus === 9") 支付已关闭
                                        font(v-if="scope.row.payStatus === 10") 退款已取消
                                el-table-column(prop="payAmount" label="支付金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.payAmount") ￥{{parseFloat(scope.row.payAmount).toFixed(2)}}元
                                el-table-column(prop="createTime" label="报名时间" align='center' width='100')
                                el-table-column(prop="refundScale" label="退款比例" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundScale !== null") {{scope.row.refundScale}}%
                                el-table-column(prop="refundFee" label="退款金额" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.refundFee !== null") ￥{{parseFloat(scope.row.refundFee).toFixed(2)}}元
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(:collapse="isCollapse" )
                                            el-submenu(index="2")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="2-1" @click="updateBench(scope.row,0)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 设为参赛
                                                    el-menu-item(index="2-2" @click="delEnroll(1,scope.row)" :disabled="ruleForm.enrollDisabled||ruleForm.matchStatus==4") 删除人员
            //- el-row(style="padding-top:10px")
            //-     el-col(:span="24")
            //-         el-card(shadow="never")
            //-             div(slot="header")
            //-                 font.font_label add对阵表
            //-             div
            //-                 div(class="marginBottom")
            //-                     el-button(v-for="matchRound of matchTableData" :key="matchRound.round" :class="{active: index === isActive}" @click="chooseRound(matchRound.round, index)") {{ matchRound.round }}R
            //-                 el-table(:data="playUsers" border :span-method="spanMethod")
            //-                     el-table-column(prop="matchTime" label="比赛时间" align="center")
            //-                     el-table-column(prop="name" label="姓名" align="center")
            //-                     el-table-column(prop="memberAccount" label="会员账号" align="center")
            //-                     el-table-column(prop="sex" label="性别" align="center")
            //-                     el-table-column(prop="age" label="年龄" align="center")
            //-                     el-table-column(prop="level" label="级别" align="center")
            //-                     el-table-column(prop="totalScore" label="积分" align="center")
            //-                     el-table-column(prop="memberType" label="会员类型" align="center")
            //-                     el-table-column(prop="yieldScore" label="让分" align="center" width="300")
            el-dialog(:title="`添加${wildCard ? '外卡' : '人员'}`"  :visible.sync="addVisible" width="80%" :append-to-body='true' :modal-append-to-body='false')
                el-row
                   el-col(:span="11")
                      el-card(shadow="never")
                        div(slot="header")
                            el-row
                                el-col(:span='22')
                                    el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                                el-col(:span='2')
                                    el-button(@click="getLeftData" style='float:right;' icon='el-icon-search') 查询
                        div
                          el-table(:data="leftData" border  @selection-change="checkAll" max-height="300")
                              el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="gender" label="性别" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                              el-table-column(prop="level" label="级别" align='center'  )
                              el-table-column(prop="mobile" label="手机号码" align='center' )
                              el-table-column(prop="idCard" label="身份证号" align='center'  )
                              el-table-column(prop="accountType" label="账户属性" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.accountType === 0") 一般账户
                                    font(v-if="scope.row.accountType === 1") 青少年账户
                          el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
                   el-col(:span="2")
                      div.opSetting
                          div(@click="handelSelect" )
                              el-button(style='padding:10px'    icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                          div.spacing(@click="handleRemoveSelect")
                              el-button(style='padding:10px' icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
                   el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header")
                                font.font_label 已选择的{{ wildCard ? '外卡' : '会员' }}
                            div
                                el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300")
                                    el-table-column(type="selection" align='center')
                                    el-table-column(prop="name" label="姓名" align='center')
                                    el-table-column(prop="gender" label="性别" align='center' )
                                        template(slot-scope="scope")
                                            font(v-if="scope.row.gender === 0") 男
                                            font(v-if="scope.row.gender === 1") 女
                                    el-table-column(prop="level" label="级别" align='center' )
                                    el-table-column(prop="mobile" label="手机号码" align='center' )
                                    el-table-column(prop="idCard" label="身份证号" align='center'  )
                                    el-table-column(prop="accountType" label="账户属性" align='center'  )
                                      template(slot-scope="scope")
                                        font(v-if="scope.row.accountType === 0") 一般账户
                                        font(v-if="scope.row.accountType === 1") 青少年账户
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary") 确 定
                    el-button(@click="addVisible=false") 取 消
            el-dialog(title="查看家长"  :visible.sync="viewParentVisible" width="50%" :append-to-body='true' :modal-append-to-body='false')
                el-row
                   el-col(:span="24")
                        div
                          el-table(:data="parentList" border  @selection-change="checkAll" max-height="300")
                              //- el-table-column(type="selection" align='center')
                              el-table-column(prop="name" label="姓名" align='center')
                              el-table-column(prop="mobile" label="会员账号" align='center')
                              el-table-column(prop="accountType" label="账户属性" align='center'  )
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.accountType === 0") 一般账户
                                    font(v-if="scope.row.accountType === 1") 青少年账户
                              el-table-column(prop="level" label="级别" align='center'  )
                              el-table-column(prop="type" label="会员类型" align='center' width="130")
                                 template(slot-scope="scope")
                                    font(v-if="scope.row.type == 1") 注册会员
                                    font(v-if="scope.row.type == 2") 初始会员
                                    font(v-if="scope.row.type == 3") 荣誉会员
            //争议弹框
            el-dialog(:title="argueTitle" :visible.sync="argueVisible" :append-to-body='true' :modal-append-to-body='false')
                div(v-if="addOrViewArgue" style="margin-top:-27px;")
                    el-input(v-model="argueForm.argue" type="textarea" :rows="10" resize="none"  placeholder="请输争议内容")
                div(v-if="!addOrViewArgue" style="min-height:160px;") {{argueForm.argue}}
                span.dialog-footer(slot="footer")
                    el-button(v-if="addOrViewArgue" @click="comfirmArgue" type="primary") 确 定
                    el-button(@click="argueVisible=false") 取 消
            el-dialog(title="退款" :visible.sync='refundVisible' :append-to-body='true' :modal-append-to-body='false')
                el-form(:model="refundForm" ref="refundForm" style="padding:30px;")
                    el-row
                       el-col(:span="8")
                            div(style="float:right")
                              el-radio(v-model="radio" label="1" border) 按比例退款
                       el-col(:span="16")
                            el-form-item(prop="refundScale" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio=='1' ? false : true" v-model="refundForm.refundScale" :min=0 :max=100 )
                    el-row
                        el-col(:span="8")
                            div(style="float:right")
                                el-radio(v-model="radio" label="2" border) 按固定金额退款
                        el-col(:span="16")
                            el-form-item(prop="refundFee" label="：" style="display:inherit;")
                                el-input-number(:disabled="radio=='2' ? false : true" v-model="refundForm.refundFee" :min=0 :max="refundFeeMax" :precision="2" )
                    el-row
                        el-col(:span="8" style="margin-right:26px")
                            div(style="text-align:right;margin-right:-14px") 退款说明：
                        el-col(:span="8")
                            el-input(v-model="refundForm.refundDesc" type="textarea" :rows=6 resize="none" maxlength="99" show-word-limit)
                span.dialog-footer(slot="footer")
                    el-button(@click="comfirmRefundRee" type="primary" :disabled='refundBtn') 确 定
                    el-button(@click="refundVisible=false") 取 消
        //- SortNumber(v-if='SortNumberVisible', ref="SortBmber",@refreshDataList='choseSortBmber')
        //- SortFormat(v-if='SortFormatrVisible', ref="SortFormatr")
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
import table from './table.js'
// import SortNumber from './SortNumber'
// import SortFormat from './SortFormat'
export default {
  data () {
    return {
      isCollapse: true,
      table: {
        columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      SortFormatrVisible: false,
      SortNumberVisible: false,
      argueVisible: false,
      addOrViewArgue: true,
      refundBtn: false,
      argueTitle: '',
      argueForm: {
        argue: ''
      },
      refundList: [],
      regMember: '', //注册会员
      initMember: '', //初始化会员
      honour: '', //荣誉会员
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      memberName: '',
      buttonSize: 'large',
      options: [],
      value: '',
      leftData: [],
      rightData: [], // 右边列表
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      visible: false,
      addVisible: false,
      wildCard: null,
      refundVisible: false,
      title: '参赛人员管理',
      enrollData: [],
      enrollDataOne: [],
      enrollDataTwo: [],
      enrollDataChange: [],
      enrollDataOneChange: [],
      enrollDataTwoChange: [],
      ruleForm: {
        id: '',
        ctId: '',
        matchName: '',
        orgId: '',
        city: '',
        province: '',
        placeId: '',
        ctType: '',
        applySize: '',
        projectType: null,
        level: '',
        bench: '1',
        applyDate: [],
        matchSignStartTime: '',
        matchSignEndTime: '',
        matchStartTime: '',
        imgList: '',
        gameDescription: '',
        matchDescription: '',
        imgDetailList: '',
        repeatSign: '0',
        genderLimit: '2',
        ageLimit: '',
        ageMinMen: undefined,
        ageMaxMen: undefined,
        ageMinWomen: undefined,
        ageMaxWomen: undefined,
        scoreMin: '',
        ctRefundList: [],
        byx1: '',
        verifyReason: '',
        orderForm: 1
      },
      enrollList: {
        ctId: '',
        bench: '0', //是否替补队员 0:否 1:是
        matchType: 1, //业务类型（1分级赛、2俱乐部）,
        mbMemberList: []
      },
      payRefund: null,
      refundForm: {
        refundScale: undefined,
        refundFee: undefined,
        refundDesc: ''
      },
      radio: undefined,
      loading: null,
      refundFeeMax: 0,
      matchTableData: [], // 对阵表数据
      playUsers: [], // 对阵人员
      isActive: 0 ,// 动态显示按钮颜色
      parentList:[],
      viewParentVisible:false
    }
  },
  components: {
    // SortNumber,
    // SortFormat
  },
  methods: {
    // 调整序列号
    openSortNumber () {
      this.SortNumberVisible = true
      this.$nextTick(() => {
        this.$refs.SortBmber.init(
          this.enrollDataOne,
          this.ruleForm.id,
          this.ruleForm.projectType
        )
      })
    },

    choseSortBmber () {
      this.SortNumberVisible = false
    },
    // 调整赛制
    openSortFormatr () {
      this.SortFormatrVisible = true
      this.$nextTick(() => {
        this.$refs.SortFormatr.init()
      })
    },
    // 合并单元格
    spanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    //刷新添加人员左边table
    getLeftData () {

      let arrId = []
      for (let i of this.enrollData) {
        arrId.push(i.mbId)
      }
      for (let i of this.rightData) {
        arrId.push(i.id)
        console.log(i.id)
      }
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getMemberList`),
        method: 'post',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.memberName,
          status: 1, //只查询已实名认证的会员
          ids: arrId.join()
        })
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.list.rows
          this.totalPage = data.list.total
        } else {
          this.leftData = []
          this.totalPage = 0
        }
      })
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //添加人员入库
    addEnroll () {
      if (this.rightData.length === 0) {
        this.$message.error('没有要添加的会员!')
      } else if (this.rightData.length > 0) {
        this.openFullScreen()
        if (this.wildCard) {
          this.enrollList.wildCard = this.wildCard
        }
        this.enrollList.mbMemberList = []
        this.rightData.forEach((data) => {
          let orderFee = ''
          if (data.type === 1) {
            orderFee = this.regMember
          } else if (data.type === 2) {
            orderFee = this.initMember
          } else if (data.type === 3) {
            orderFee = this.honour
          }
          this.enrollList.mbMemberList.push({
            id: data.id,
            name: data.name,
            type: data.type,
            orderFee: orderFee,
            level: data.level,
            accountType:data.accountType
          })
        })

        //先验证每个会员是否满足当前赛事报名条件
        this.$http({
          url: this.$http.adornUrl(`/elEnroll/checkEnrollMember`),
          method: 'post',
          data: this.enrollList
        }).then((data) => {
          console.log(data)
          if (data && data.code === 0) {
            if (data.state) {
              console.log('验证通过')
              this.$http({
                url: this.$http.adornUrl(`/elEnroll/save`),
                method: 'post',
                data: this.enrollList
              }).then((data) => {
                console.log(data)
                if (data && data.code === 0) {
                  this.$message.success('添加成功!')
                  this.addVisible = false
                  this.init(this.ruleForm.id)
                } else {
                  this.$message.success('添加失败!')
                }
                this.loading.close()
              })
            } else {
              this.$message.error(data.info)
            }
          }
          this.loading.close()
        })
      }
    },
    //添加人员页面
    addEnrollView (wildCard) {
      this.addVisible = true
      this.memberName = ''
      this.rightData = []
      this.enrollList = {}
      this.nowSelectRightData = []
      this.nowSelectRightData = [] // 右边选中列表数据
      this.enrollList.ctId = this.ruleForm.id
      // 外卡
      if (wildCard === 'wildCard') {
        this.wildCard = 1
      } else {
        this.wildCard = null
      }
      this.getLeftData()
    },
    initEnrollDataChange () {
      this.enrollDataChange = []
      if (
        this.enrollDataOneChange.length === 0 &&
        this.enrollDataTwoChange.length === 0
      ) {
        this.$message.error('提示：请勾选要操作的人员！')
        return true
      }
      this.enrollDataChange = this.enrollDataOneChange.concat(
        this.enrollDataTwoChange
      )
      console.log(this.enrollDataChange, 555)

      return false
    },
    //初始化记录争议弹框
    initDiaLogArgue (row, val) {
      this.argueVisible = true
      this.argueForm.id = ''
      if (val === 1) {
        this.argueForm.argue = row.argue || ''
        this.addOrViewArgue = true
        this.argueTitle = '记录争议内容'
        this.argueForm.id = row.enrollId
      } else {
        this.argueForm.argue = row.argue || '无争议!'
        this.addOrViewArgue = false
        this.argueTitle = '查看争议'
      }
    },
    //记录争议提交事件
    comfirmArgue () {
      // if (this.argueForm.argue.length === 0) {
      //     this.$message.error('争议内容不能为空！')
      //     return
      // }
      if (this.argueForm.argue.length > 500) {
        this.$message.error('争议内容长度不能超过500个字符')
        return
      }
      this.$http({
        url: this.$http.adornUrl(`/elEnroll/update`),
        method: 'post',
        data: this.argueForm
      }).then((data) => {
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.argueVisible = false
          this.init(this.ruleForm.id)
        }
      })
    },
    //退款弹窗事件
    clickRefund (btn, row) {
      console.log('退款按钮：', row)
      this.radio = undefined
      this.payRefund = {}
      //支付状态(-1全部，0未支付,1支付中,2支付成功,3支付失败,4超时,5申请退款,6退款中,7退款成功,8退款失败,9支付已关闭，10退款已取消)
      if (btn == 1) {
        //操作栏退款
        if (
          row.payStatus == 0 ||
          row.payStatus == 1 ||
          row.payStatus == 3 ||
          row.payStatus == 4
        ) {
          this.$message.error('提示：未缴费不能退款！')
          return
        }
        if (row.payStatus == 5) {
          this.$message.error('提示：已发起退款申请！')
          return
        }
        if (row.payStatus == 6 || row.payStatus == 8) {
          this.$message.error('提示：退款中！')
          return
        }
        if (row.payStatus == 7) {
          this.$message.error('提示：已完成退款！')
          return
        }
        this.payRefund.ids = row.enrollId
        this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
      } else {
        //批量退款
        // this.payRefund = null
        //替补人员不需要退费操作
        if (this.enrollDataOneChange.length === 0) {
          this.$message.error('提示：请勾选要退费的人员！')
          return
        }
        // if(this.enrollDataChange.length > 1){
        //     this.$message.error("提示：退款只能选择一个人员！")
        //     return
        // }
        // let enroll = this.enrollDataOneChange.length > 0 ? this.enrollDataOneChange : this.enrollDataTwoChange
        // this.payRefund = enroll[0]
        console.log('勾选的退款人员', this.enrollDataOneChange)
        let feeFlag = false
        let feeInfo = ''
        let idArr = []
        this.refundFeeMax = parseFloat(
          this.enrollDataOneChange[0].payAmount
        ).toFixed(2)
        this.enrollDataOneChange.forEach((row) => {
          if (
            row.payStatus == 0 ||
            row.payStatus == 1 ||
            row.payStatus == 3 ||
            row.payStatus == 4
          ) {
            feeInfo = '提示：未缴费不能退款！'
            feeFlag = true
            return
          }
          if (row.payStatus == 5) {
            feeInfo = '提示：已发起退款申请！'
            feeFlag = true
            return
          }
          if (row.payStatus == 6 || row.payStatus == 8) {
            feeInfo = '提示：退款中！'
            feeFlag = true
            return
          }
          if (row.payStatus == 7) {
            feeInfo = '提示：已完成退款！'
            feeFlag = true
            return
          }
          idArr.push(row.enrollId)
          //退款金额赋最大值
          if (this.refundFeeMax > parseFloat(row.payAmount).toFixed(2)) {
            this.refundFeeMax = parseFloat(row.payAmount).toFixed(2)
          }
        })
        if (feeFlag) {
          this.$message.error(feeInfo)
          return
        }
        console.log('已选退费人员id：', idArr)
        console.log('已选退费人员id：', idArr.toString())
        this.payRefund.ids = idArr.toString()
      }
      this.refundVisible = true
      this.refundForm.refundScale = undefined
      this.refundForm.refundFee = undefined
      this.refundForm.refundDesc = ''
      this.refundFeeMax = parseFloat(this.refundFeeMax)
    },
    //退款提交事件
    comfirmRefundRee () {
      console.log('退款信息：', this.refundForm)
      if (this.radio === undefined) {
        this.$message.error('请选择按比例或者固定金额退款!')
        return
      }
      if (this.radio === '1') {
        if (!this.refundForm.refundScale) {
          this.$message.error('请填写退款比例!')
          return
        } else {
          this.payRefund.refundScale = this.refundForm.refundScale
          this.payRefund.refundFee = undefined
          this.refundForm.refundFee = undefined
        }
      }
      if (this.radio === '2') {
        if (!this.refundForm.refundFee) {
          this.$message.error('请填写固定金额退款!')
          return
        } else {
          console.log(this.payRefund.refundFee, 11111)
          // if(this.payRefund.refundFee){

          // }
          this.payRefund.refundFee = this.refundForm.refundFee
          this.payRefund.refundScale = undefined
          this.refundForm.refundScale = undefined
        }
      }
      console.log('退款确定：', this.payRefund)
      this.refundBtn = true
      this.payRefund.refundDesc = this.refundForm.refundDesc // 退款说明
      this.$http({
        url: this.$http.adornUrl(`/elEnrollOrder/refund`),
        method: 'post',
        data: this.payRefund
      }).then((data) => {
        console.log('确定退款---' + data)
        if (data && data.code === 0) {
          this.$message.success('操作成功！')
          this.refundVisible = false
          this.refundBtn = false
          this.init(this.ruleForm.id)
        }
      })
    },
    //设置替补或主力
    // type: 0主力  1替补
    updateBench (row, type) {
      let title = type === 0 ? '是否设置为参赛人员？' : '是否设置为替补人员？'
      if (type === 1) {
        //设为替补，先判断
        if (
          row.payStatus === 2 ||
          row.payStatus === 5 ||
          row.payStatus === 6 ||
          row.payStatus === 8 ||
          row.payStatus === 10
        ) {
          this.$message.error('提示：请先进行退费操作!')
          return
        }
        if (row.wildCard === 1) {
          return this.$message.error('外卡人员不能设置为替补人员！')
        }
      }

      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          row.bench = type
          this.$http({
            url: this.$http.adornUrl(`/elEnrollOrder/updateByEnrollBench`),
            method: 'post',
            data: row
          }).then((data) => {
            if (data && data.code === 0) {
              if (data.state) {
                this.$message.success('操作成功!')
                this.init(this.ruleForm.id)
              } else {
                this.$message.error(data.info)
              }
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    //删除人员
    delEnroll (btn, row) {
      let idArr = []
      if (btn == 1) {
        //单个删除
        if (
          row.payStatus === 2 ||
          row.payStatus === 5 ||
          row.payStatus === 6 ||
          row.payStatus === 8 ||
          row.payStatus === 10
        ) {
          this.$message.error('提示：请先进行退费操作!')
          return
        }
        idArr.push(row.enrollId)
      } else {
        //批量删除
        console.log(this.enrollDataChange, 999)

        if (this.initEnrollDataChange()) {
          return
        }
        // for(let i of this.enrollDataChange){
        //     if(i.payStatus === 2 || i.payStatus === 5 || i.payStatus === 6 || row.payStatus === 8 || i.payStatus === 10){
        //         this.$message.error("提示：请先进行退费操作!")
        //         return
        //     }
        //     idArr.push(i.enrollId);
        // }
        this.enrollDataChange.forEach((i) => {
          console.log(i.payStatus, 5)
          if (i.payStatus) {
            if (
              i.payStatus === 2 ||
              i.payStatus === 5 ||
              i.payStatus === 6 ||
              i.payStatus === 8 ||
              i.payStatus === 10
            ) {
              this.$message.error('提示：请先进行退费操作!')
              return
            }
          }
          idArr.push(i.enrollId)
        })
        console.log(idArr, 998)
      }
      console.log('要删除的参赛人员：', idArr.toString())
      this.$confirm('是否删除该人员', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.$http({
            url: this.$http.adornUrl(`/elEnroll/deleteByEnroll`),
            method: 'post',
            params: this.$http.adornParams({
              ids: idArr.join()
            })
          }).then((data) => {
            if (data && data.code === 0) {
              if (data.state) {
                this.$message.success('删除成功')
                this.init(this.ruleForm.id)
              } else {
                this.$message.error(data.info)
              }
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消')
        })
    },
    // 查看家长
    viewParent(row){
      console.log(row)
      this.viewParentVisible=true
      let data={
          bindMbIds:[row.mbId]
      }
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getParentMembersByTeen`),
        method: 'post',
        data
      }).then((data) => {
        if (data && data.code === 0) {
          console.log('家长列表', data)
          this.parentList=data.data
        }
      })
    },
    init (id) {
      this.ruleForm.id = id
      this.radio = undefined
      this.visible = true
      this.regMember = ''
      this.initMember = ''
      this.honour = ''
      this.enrollData = []
      this.enrollDataOne = []
      this.enrollDataTwo = []
      this.enrollDataChange = []
      this.enrollDataOneChange = []
      this.enrollDataTwoChange = []

      //回显
      this.$http({
        url: this.$http.adornUrl(`/ctCompetition/getId/` + id),
        method: 'get'
      })
        .then((data) => {
          if (data && data.code === 0) {
            this.ruleForm = data.bean
            console.log('竞赛信息：', data.bean)
            if (this.ruleForm.projectType == 1) {
              //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
              this.ruleForm.orderForm = 0
            } else if (this.ruleForm.projectType == 2) {
              //双打默认按级别和-积分和排序
              this.ruleForm.orderForm = 1
            }
            let joinCount = this.ruleForm.joinCount //已报名参赛人员的人数
            let applySize = this.ruleForm.applySize //赛事签位数
            let date1 = new Date().getTime()
            let date2 = new Date(this.ruleForm.matchStartTime).getTime()
            let date3 = new Date(this.ruleForm.matchSignStartTime).getTime()
            let date4 = new Date(this.ruleForm.matchSignEndTime).getTime()
            this.ruleForm.enrollDisabled = true
            if (date1 < date3) {
              this.ruleForm.statusName = '未开始'
              this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount < applySize
            ) {
              this.ruleForm.statusName = '报名中'
              this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount >= applySize &&
              this.ruleForm.bench === 1
            ) {
              this.ruleForm.statusName = '报满可替'
              this.ruleForm.enrollDisabled = false
            } else if (
              date1 >= date3 &&
              date1 <= date4 &&
              joinCount >= applySize &&
              this.ruleForm.bench === 0
            ) {
              this.ruleForm.statusName = '已报满'
              this.ruleForm.enrollDisabled = false
            } else if (date1 > date4 && date1 < date2) {
              this.ruleForm.statusName = '报名结束'
              this.ruleForm.enrollDisabled = false
            } else if (date1 >= date2) {
              this.ruleForm.statusName = '已开赛'
              this.ruleForm.enrollDisabled = true
            }
            this.refundList = data.rList
            for (let i of data.eList) {
              if (i.type === 1) {
                this.regMember = i.price
              } else if (i.type === 2) {
                this.initMember = i.price
              } else if (i.type === 3) {
                this.honour = i.price
              }
            }
          }
        })
        .then(() => {
          this.getEnrollData(id)
          // 获取对阵表数据
          this.getMatchTableData(id)
        })
    },
    /**
     * 与当前时间比较 返回小时
     * @param date2
     * @returns {number}
     */
    getDateDiff (date2) {
      let startDate = new Date(date2)
      let endDate = new Date()
      if (startDate.getTime() > endDate.getTime()) {
        let hour = (startDate.getTime() - endDate.getTime()) / 1000 / 60 / 60
        return hour
      } else {
        return -1
      }
    },
    orderChange () {
      this.init(this.ruleForm.id)
    },
    // 参赛人员管理-对阵表信息
    getMatchTableData (id) {
      // this.playUsers = []
      // this.$http({
      //   url: this.$http.adornUrl(
      //     `/ctCompetition/operation/player-manage/against-list/${id}`
      //   ),
      //   method: 'get'
      // }).then((data) => {
      //   if (data && data.data.code === 0) {
      //     this.matchTableData = data.data // array
      //   }
      // })
    },
    // 点击选择对阵表查看
    chooseRound (round, index) {
      this.isActive = index
      this.matchTableData.forEach((e) => {
        if (e.round === round) {
          e.infoList.map((ele) => {
            ele.playerList.map((item) => {
              item.matchTime = ele.matchTime
              item.groupId = ele.groupId
              this.playUsers.push(item)
            })
          })
        }
      })
    },
    // 列表刷新
    getEnrollData (id) {
      let params = { ctId: id }
      if (this.ruleForm.projectType == 1) {
        //单打默认排序,按照参赛人员年度积分倒序（年度积分为今日之前365天积分和），多的排在前面。
        params.orderForm = 0
      } else if (this.ruleForm.projectType == 2) {
        //双打默认按级别和-积分和排序
        params.orderForm = 1
      }
      this.$http({
        url: this.$http.adornUrl(`/elEnrollOrder/getByCtId`),
        method: 'post',
        params: this.$http.adornParams(params)
      }).then((data) => {
        if (data && data.code === 0) {
          console.log('参赛人员列表：', data)
          this.enrollData = data.list
          this.table.data = data.list
          this.enrollDataOne = []
          this.enrollDataTwo = []
          for (let i of this.enrollData) {
            if (i.refundScale === null && i.refundFee !== null) {
              i.refundScale = ((i.orderFee / i.refundFee) * 100).toFixed(2)
            }
            if (i.refundFee === null && i.refundScale !== null) {
              i.refundFee = ((i.orderFee * i.refundScale) / 100).toFixed(2)
            }

            if (i.bench === 0) {
              //主力
              this.enrollDataOne.push(i)
            }
            if (i.bench === 1) {
              //替补
              this.enrollDataTwo.push(i)
            }
          }
        }
      })
    },
    checkAll (val) {
      this.nowSelectData = val
    },
    checkRightAll (val) {
      this.nowSelectRightData = val
    },
    // 选中
    handelSelect () {
      this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
      this.handleRemoveTabList(this.nowSelectData, this.leftData)
      this.nowSelectData = []
    },
    // 取消
    handleRemoveSelect () {
      this.leftData = this.handleConcatArr(
        this.leftData,
        this.nowSelectRightData
      )
      this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
      this.nowSelectRightData = []
    },
    handleConcatArr (rightData, nowSelectData) {
      let arr = []
      arr = arr.concat(rightData, nowSelectData)
      return arr
    },
    handleRemoveTabList (isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i]['name'] === originalArr[k]['name']) {
              originalArr.splice(k, 1)
            }
          }
        }
      }
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getLeftData()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getLeftData()
    },
    //主力勾选事件
    enrollOneChange (val) {
      this.enrollDataOneChange = val
    },
    //主力勾选事件
    enrollTwoChange (val) {
      this.enrollDataTwoChange = val
    },
    //导出excel
    exportExcel () {
      console.log('表头：', this.table.columns)
      let exportData = []
      console.log('表数据：', exportData)
      for (let i of this.table.data) {
        if (i.bench === 0) {
          i.genderName = { 0: '男', 1: '女' }[i.gender]
          i.memberTypeName = {
            1: '注册会员',
            2: '初始会员',
            3: '荣誉会员'
          }[i.memberType]
          i.yearScore = i.yearScore || 0
          const player = JSON.parse(JSON.stringify(i))
          if (player.mobile) {
            player.mobile = 'keepString' + player.mobile
          }
          if (player.idCard) {
            player.idCard = 'keepString' + player.idCard
          }
          exportData.push(player)
        }
      }
      if (exportData == null || exportData.length === 0) {
        this.$message.info('没有要导出的数据!')
        return
      }
      let title = this.ruleForm.matchName || ''
      this.$export
        .excel({
          columns: this.table.columns,
          data: exportData,
          title: title + '参赛人员'
        })
        .then(() => {
          this.$message.success('导出表格成功')
        })
    }
  }
}
</script>
<style>
.active {
  background: #02b90d !important;
  color: #fff !important;
}
.marginBottom {
  margin-bottom: 20px;
}
.width_label {
  width: 180px;
}
.opSetting {
  text-align: center;
  margin-top: 30px;
}
.spacing {
  margin-top: 10px;
}
.font_label {
  font-weight: bold;
  font-size: 18px;
}

.el-radio.is-bordered {
  width: 140px;
  padding: 12px 20px 0 10px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 40px;
}

/* 分页样式 */
.el-pager li {
  padding: 0 4px;
  font-size: 13px;
  min-width: 20.5px;
  height: 28px;
  line-height: 28px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}
.headTitle {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
